module.exports = __webpack_public_path__ + "img/img11.34a5709a.png";